import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { usePagination } from "src/hooks/usePagination";
import { useOutsideClick } from "src/hooks/useOutsideClick";
import { SortingState } from "@tanstack/react-table";
import { Transition } from "@headlessui/react";
import Button from "src/features/fields/components/Button";
import Table from "src/features/fields/components/Table";
import POFilter from "src/features/fields/container/POFilter";
import { createColumnHelper } from "@tanstack/react-table";
import moment from "moment";
import FilterIcon from "src/assets/filter.svg";
import { getOrderTypeException, getOrderTypeExemptionVersioning } from "src/services/order-api";
import { queryDivisionDetails } from "../../../services/division-api";
import { poActions } from "src/context/po-slice";
import { appendParams } from "src/utils/utils";
import { getAllCompanyDetails } from "src/services/company-api";   //M10-11693
//M10-11693
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "src/components/ui/select.component";
import { Input } from "src/components";
//M10-11693
//M10-13389
import Book from "src/assets/eye-show.svg"
//M10-13389

const cndnRemarksMapper: Record<number, string> = {
    1: "RO",
    2: "SAO-NP",
    3: "CN-NP",
    4: "POB",
    // 5 (PUC) has no order behaviour yet, so it is deliberately absent here.
    6: "SAO-CN",
};

const OrderTypeException = () => {
    const [loading, setLoading] = useState(false);
    const { orderTypeExceptionTableData, poFiltersData, orderTypeExceptionFilters } = useSelector((state: any) => state.po);
    const { pagination, onPaginationChange, pageIndex, pageSize, resetPagination } = usePagination();
    const [totalRowCount, setTotalRowCount] = useState(10);
    const [isFiltersShown, setIsFiltersShown] = useState<boolean>(false);
    const [sorting, setSorting] = useState<SortingState>();
    const [globalSearch, setGlobalSearch] = useState("");
    const [searchCategory, setSearchCategory] = useState("counter_code");   //M10-11693
    //M10-13389
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalData, setModalData] = useState<any>(null);
    const [modalLoading, setModalLoading] = useState(false);
    //M10-13389

    const dispatch = useDispatch();
    //M10-13389
    const fetchVersionData = async (rowData: any) => {
        try {
            setModalLoading(true);
            setIsModalOpen(true);

            const response = await getOrderTypeExemptionVersioning(rowData?.order_type_exceptionid, rowData?.company_code);
            setModalData(response?.data?.logs);
        } catch (err: any) {
            console.error(err);
        } finally {
            setModalLoading(false);
        }
    };
    //M10-13389

    const ref = useOutsideClick(() => {
        setIsFiltersShown(false);
    });
    //M10-11693
    const searchOptions = [
        { label: "Counter Code", value: "counter_code" },
        { label: "Item Code", value: "item_code" },
        { label: "Stockist Medvol Code", value: "medvol_stockist_code" },
        { label: "Company Stockist Code", value: "stockist_code" },
    ];
    const cndnRemarks = [
        { label: "Regular Order", value: 1 },
        { label: "Supply Against Order - No Replenishment", value: 2 },
        { label: "Credit Note - No Replenishment", value: 3 },
        { label: "POB", value: 4 },
        { label: "Supply Against Order - Credit Note", value: 6 },
    ]
    //M10-11693

    const [_, setSearchParams] = useSearchParams();

    const columnHelper = createColumnHelper();
    const columns = [
        columnHelper.accessor("novu_metadata.company.companyName", {
            header: () => "Company Name",
            enableSorting: true,
            cell: (info: any) => info.getValue() || "-",
        }),
        columnHelper.accessor("division_name", {

            header: () => "Division Name",
            enableSorting: true,
            cell: (info: any) => info.row.original?.novu_metadata?.divisions?.[0]?.divisionName || "-",

        }),
        columnHelper.accessor("counter_code", {
            header: () => "Counter Code",
            enableSorting: true,
            cell: (info: any) => info.getValue() || "-",
        }),
        columnHelper.accessor("counter_name", {
            header: () => "Counter Name",
            enableSorting: true,
            cell: (info: any) => info.row.original?.novu_metadata?.counters?.[0]?.counterName || "-",
        }),
        columnHelper.accessor("location_code", {
            header: () => "Location Code",
            enableSorting: true,
            cell: (info: any) => info.getValue() || "-",
        }),
        columnHelper.accessor("location_name", {
            header: () => "Location Name",
            enableSorting: true,
            cell: (info: any) => info.row.original?.novu_metadata?.counters?.[0]?.locationName || "-",
        }),
        columnHelper.accessor("item_code", {
            header: () => "Item Code",
            enableSorting: true,
            cell: (info: any) => info.getValue() || "-",
        }),
        columnHelper.accessor("item_name", {
            header: () => "Item Name",
            enableSorting: true,
            cell: (info: any) => info.row.original?.novu_metadata?.products?.[0]?.productName || "-",   //M10-12011
        }),

        columnHelper.accessor("medvol_code", {
            header: () => "MedVol Code",
            enableSorting: true,
            cell: (info: any) => info.row.original?.novu_metadata?.stockists?.[0]?.phCode || "-",   //M10-12011
        }),
        columnHelper.accessor("stockist_code", {
            header: () => "Stockist Code",
            enableSorting: true,
            cell: (info: any) => info.getValue() || "-",
        }),
        columnHelper.accessor("stockist_name", {
            header: () => "Stockist Name",
            enableSorting: true,
            cell: (info: any) => info.row.original?.novu_metadata?.stockists?.[0]?.firmName || "-", //M10-12011
        }),
        columnHelper.accessor("state_name", {
            id: "state_name",
            header: () => "State Name",
            enableSorting: true,
            cell: (info: any) => info.row.original?.novu_metadata?.states?.[0]?.stateName || "-",   //M10-12011
        }),
        columnHelper.accessor("created_date", {
            header: () => "Created Date",
            enableSorting: true,
            cell: (info: any) => {
                const date = info.getValue();
                return date
                    ? moment(date).tz("Asia/Kolkata").format("DD MMM YYYY")
                    : "-";
            },
        }),
        columnHelper.accessor("cndn_remarks_code_int", {
            header: () => "Order Type",
            enableSorting: true,
            cell: (info: any) => {
                const code = info.getValue();
                return cndnRemarksMapper[code] || "-";
            },
        }),
        columnHelper.accessor("module_desc", {
            header: () => "Module",
            enableSorting: true,
            cell: (info: any) => info.getValue() || "-",
        }),
        //M10-13389
        columnHelper.accessor("action", {
            header: "Versioning",
            cell: (info: any) => {
                const rowData = info?.row?.original;

                return (
                    <Button onClick={() => fetchVersionData(rowData)}>
                        <img src={Book} alt="view" className="w-6 h-6" />
                    </Button>
                );
            },
        })
        //M10-13389
    ];

    const fetchDetails = () => {
        setLoading(true);

        setSearchParams({
            pageSize: pageSize.toString(),
            pageIndex: pageIndex.toString(),
        });

        const companyParams = appendParams(Array.isArray(orderTypeExceptionFilters?.company) ? orderTypeExceptionFilters.company : [], "company", "code");

        const divisionParams = appendParams(
            Array.isArray(orderTypeExceptionFilters?.division) ? orderTypeExceptionFilters.division : [],
            "division",
            "company_divisioncode"
        );

        const stateParams = appendParams(Array.isArray(orderTypeExceptionFilters?.state) ? orderTypeExceptionFilters.state : [], "state", "state_code");

        const cndnRemarkParams = appendParams(Array.isArray(orderTypeExceptionFilters?.cndnRemark) ? orderTypeExceptionFilters.cndnRemark : [], "cndn_remark", "value");    //M10-11693

        let filtersQuery = [companyParams, divisionParams, stateParams, cndnRemarkParams].join("&"); //M10-11693

        filtersQuery.endsWith("&&") && (filtersQuery = filtersQuery.slice(0, -1));
        filtersQuery.endsWith("&") && (filtersQuery = filtersQuery.slice(0, -1));

        getOrderTypeException(
            pageIndex - 1,
            pageSize,
            filtersQuery,
            orderTypeExceptionFilters?.company?.[0]?.code === 618 ? orderTypeExceptionFilters?.company?.[0]?.code : 0,
            searchCategory, globalSearch
        )
            .then((res) => {
                dispatch(poActions.setOrderTypeExceptionTableData(res?.data?.data?.data || []));
                setTotalRowCount(res?.data?.data?.totalDataCount);
            })
            .catch((err) => {
                console.log(err);
            })
            .finally(() => setLoading(false));
    };

    //M10-11693     
    useEffect(() => {
        resetPagination();
    }, [
        orderTypeExceptionFilters?.company,
        orderTypeExceptionFilters?.division,
        orderTypeExceptionFilters?.state,
        orderTypeExceptionFilters?.cndnRemark,
        globalSearch
    ]);
    //M10-11693

    useEffect(() => {
        fetchDetails();
    }, [pageSize, pageIndex, sorting, globalSearch]);

    let pageCount = Math.ceil(totalRowCount / (pageSize ?? 1));
    if (totalRowCount % 10 === 0) {
        pageCount--;
    }

    let timerId: any;
    const handleSearch = (searchQuery: string) => {
        if (timerId) clearTimeout(timerId);

        timerId = setTimeout(() => {
            resetPagination();
            setGlobalSearch(searchQuery);
        }, 500);
    };

    useEffect(() => {
        //M10-11693
        getAllCompanyDetails()
            .then((res) =>
                dispatch(poActions.setPoFiltersData({ key: "company", value: res.data }))
            )
            .catch((err) => console.log(err));
        //M10-11693
        if (orderTypeExceptionFilters?.company?.length) {
            queryDivisionDetails(`/details/?fields=division_name&company_code=${orderTypeExceptionFilters?.company[0]?.code}`)
                .then((res) => dispatch(poActions.setPoFiltersData({ key: "orderTypeExceptionDivision", value: res.data })))
                .catch((err) => console.log(err));
        } else {
            dispatch(poActions.setPoFiltersData({ key: "orderTypeExceptionDivision", value: [] }));
            dispatch(poActions.setOrderTypeExceptionFilters({ key: "division", value: [] }));
        }

    }, [orderTypeExceptionFilters?.company, dispatch]); //M10-11693
    //M10-11693
    useEffect(() => {
        if (globalSearch?.trim()) {
            fetchDetails();
        }
    }, [searchCategory]);
    //M10-11693

    return (
        <>
            <Transition
                as={Fragment}
                show={isFiltersShown}
                enter="transition transition ease-in-out duration-200 transform"
                enterFrom="translate-x-full"
                enterTo="translate-x-0"
                leave="transition  ease-in-out duration-200 transform"
                leaveFrom="translate-x-0"
                leaveTo="translate-x-full"
            >
                <div className="fixed right-0 inset-0 top-0 z-[500]">
                    <POFilter
                        ref={ref}
                        companyDetails={poFiltersData?.company || []}
                        divisionDetails={poFiltersData?.orderTypeExceptionDivision || []}
                        stateDetails={poFiltersData?.state || []}
                        cndnRemarkDetails={cndnRemarks || []}   //M10-11693
                        source="OrderTypeException"
                        onCloseClick={() => setIsFiltersShown(false)}
                    />
                </div>
            </Transition>

            <div className="flex justify-end float-right gap-2">

                {/* Search Box */}
                <div className="flex items-center gap-2 w-[500px] rounded-md overflow-hidden border border-gray-300 bg-white">
                    <Select value={searchCategory} onValueChange={setSearchCategory}>
                        <SelectTrigger className="w-[360px] rounded-none border-none bg-white text-gray-700 focus:ring-0 focus:outline-none focus:shadow-none">
                            <SelectValue placeholder="Search By" />
                        </SelectTrigger>
                        <SelectContent className="bg-white">
                            {searchOptions.map((option) => (
                                <SelectItem key={option.value} value={option.value}>
                                    {option.label}
                                </SelectItem>
                            ))}
                        </SelectContent>
                    </Select>

                    <Input
                        placeholder="Search"
                        debounceTime={500}
                        value={globalSearch}
                        onChange={(e) => handleSearch(e.target.value.trim())}
                        containerClasses="w-full px-3 py-1 text-gray-700 border-none bg-white focus:outline-none focus:ring-0 focus:shadow-none"
                    />
                </div>

                {/* Filters Button */}
                <Button
                    className="relative flex items-center gap-1 px-4 border"
                    onClick={() => setIsFiltersShown(true)}
                >
                    Filters <img src={FilterIcon} className="w-5 h-5" />
                    {orderTypeExceptionFilters?.filterCount > 0 && (
                        <span className="absolute -top-1 -right-1 flex items-center justify-center w-5 h-5 text-xs text-white bg-red-500 rounded-full">
                            {orderTypeExceptionFilters?.filterCount}
                        </span>
                    )}
                </Button>

                {/* Retrieve Button */}
                <Button
                    onClick={fetchDetails}
                    loaderSize="small"
                    className="h-auto py-2 border"
                >
                    Retrieve
                </Button>
            </div>

            <Table
                title="Order Type Exception Requests"
                subtitle="View and manage all your order type exception requests."
                columns={columns}
                data={orderTypeExceptionTableData ?? []}
                isLoading={loading}
                isGlobalSearch={true}
                manualPagination={true}
                pageCount={pageCount}
                pagination={pagination}
                onPaginationChange={onPaginationChange}
                sorting={sorting}
                onSortingChange={setSorting}
                manualSorting={true}
                showSearch={false}
                onGlobalSearch={handleSearch}
            />
            {/* M10-13389 */}
            {isModalOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
                    <div className="bg-white p-6 rounded-lg w-[800px] max-h-[80vh] overflow-auto">
                        <h2 className="text-lg font-semibold mb-4">Versioning History</h2>

                        {modalLoading ? (
                            <p>Loading...</p>
                        ) : modalData?.length > 0 ? (
                            <table className="w-full border border-gray-200 text-sm">
                                <thead className="bg-gray-100 sticky top-0">
                                    <tr>
                                        <th className="border p-2">Created By</th>
                                        <th className="border p-2">Division</th>
                                        <th className="border p-2">Counter Code</th>
                                        <th className="border p-2">Counter Name</th>
                                        <th className="border p-2">Company Name</th>
                                        <th className="border p-2">Stockist Code</th>
                                        <th className="border p-2">Order Type</th>
                                        <th className="border p-2">Active Status</th>
                                        <th className="border p-2">Remarks</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {modalData?.map((item: any, index: number) => (
                                        <tr key={index} className="hover:bg-gray-50">
                                            <td className="border p-2">
                                                {item.created_by?.name || '-'}
                                            </td>
                                            <td className="border p-2">{item?.input?.metadata?.divisions?.[0]?.divisionName}</td>
                                            <td className="border p-2">
                                                {item?.input?.counter_code || '-'}
                                            </td>
                                            <td className="border p-2">
                                                {item?.input?.metadata?.counters?.[0]?.counterName || '-'}
                                            </td>
                                            <td className="border p-2">
                                                {item?.input?.metadata?.company?.companyName || '-'}
                                            </td>
                                            <td className="border p-2">
                                                {item?.input?.metadata?.stockists?.[0]?.stockistCode || '-'}
                                            </td>
                                            <td className="border p-2">
                                                {item?.input?.order_type || '-'}
                                            </td>
                                            <td className="border p-2">
                                                {item?.input?.active_status || '-'}
                                            </td>
                                            <td className="border p-2">
                                                {item?.input?.reference_number || '-'}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        ) : (
                            <p>No data available</p>
                        )}

                        <div className="mt-4 text-right">
                            <Button onClick={() => setIsModalOpen(false)}>Close</Button>
                        </div>
                    </div>
                </div>
            )}
            {/* M10-13389 */}
        </>
    );
};

export default OrderTypeException;
